import { render, staticRenderFns } from "./AddServiceCategoryButton.vue?vue&type=template&id=577adfa3&"
import script from "./AddServiceCategoryButton.vue?vue&type=script&lang=js&"
export * from "./AddServiceCategoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports